import axios from 'axios';
import { backendURL } from './consts';

export const getCourse = async (id, location) => {
  const res = await axios.get(`${backendURL}/course/getCourse?courseId=${id}&location=${location}`);
  return res.data;  
}

export const getCourseById = async(id) => {
  const res = await axios.get(`${backendURL}/course/getCourseById?courseId=${id}`);
  return res.data;
}


export const createAttendence = async (data) => {
  const res = await axios.post(
    `${backendURL}/course/createAttendence`,
    data,
  );
  return res.data;
}
export const updateCourseStart = async (data) => {
  const res = await axios.post(
    `${backendURL}/course/updateAttendence/start`,
    data,
  );
  return res.data;
}

export const updateCourseEnd = async (data) => {
  const res = await axios.post(
    `${backendURL}/course/updateAttendence/end`,
    data
  );
  return res.data;
}

export const getAllCourses = async (token, seminarId, page, locationFilter) => {
  if(locationFilter) {
    locationFilter = locationFilter.replace("+", "%2B");
  }
  const res = await axios.get(
    `${backendURL}/course/getallcourses?seminarId=${seminarId}${page ? `&page=${page}` : ""}${locationFilter && `&locationFilter=${locationFilter}`}`,
    {
      headers:{
        token: `bearer ${token}`
      }
    }
  )
  return res.data;
}

export const createQrLink = async (token, data) => {
  const res = await axios.post(
    `${backendURL}/course/createQrLink`,
    data,
    {
      headers:{
        token: `bearer ${token}`
      }
    }
  );
  return res.data;
}

export const createQrLinkById = async (token, data) => {
  const res = await axios.post(
    `${backendURL}/course/createQrLinkId`,
    data,
    {
      headers:{
        token: `bearer ${token}`
      }
    }
  );
  return res.data;
}

export const getQRLink = async (qrLink) => {
  const res = await axios.get(
    `${backendURL}/course/getQrLink?qrLink=${qrLink}`
  );
  return res.data;
}

export const createCourse = async (token, data) => {
  const res = await axios.post(
    `${backendURL}/course/`,
    data,
    {
      headers:{
        token:`bearer ${token}`
      }
    }
  )
}

export const deleteCourse = async (token, data) => {
  const res = await axios.delete(
    `${backendURL}/course`,
    {
      params:{
        courseId: data.courseId,
      },
      headers:{
        token: `bearer ${token}`
      }
    }
  )
}

export const editCourse = async (token, data) => {
  const res = await axios.put(
    `${backendURL}/course/`,
    data,
    {
      headers:{
        token:`bearer ${token}`
      }
    }
  );
}

